import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './contexts/AuthContext'
import { cssVariables } from './theme'
import { modoInicial } from './stores/temaStore'

// Publica la paleta como variables CSS y fija el modo (claro/oscuro) ANTES de
// renderizar, para que no haya parpadeo de tema en el primer pintado.
const estilos = document.createElement('style')
estilos.textContent = cssVariables()
document.head.appendChild(estilos)
document.documentElement.dataset.theme = modoInicial()

const rootEl = document.getElementById('root') as HTMLElement

if (!rootEl) {
  console.error('[main] Root element not found!')
} else {
  const queryClient = new QueryClient()

  createRoot(rootEl).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </StrictMode>,
  )
}
